import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {AuthService} from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.loggedIn()) {
    return true;
  }

  const returnUrl = state.url && state.url !== '/' ? state.url : undefined;
  return router.createUrlTree(['/login'], {queryParams: returnUrl ? {returnUrl} : {}});
};
